import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Row, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { showLoader, showMessage, handleHTTPError, putSystemSettings } from 'store/actions';
import { updateSystemSettings } from 'apis';
import TextBox from 'components/controls/TextBox';
import PageContentLayout from 'components/PageContentLayout';

class GeneralSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mclversionNumber: 0,
            mctlVersionNumber: 0,
            validate: false,
        };
    }

    componentDidMount = () => {
        this.setState({
            mclVersionNumber: this.props.systemSettings.mclVersionNumber,
            mctlVersionNumber: this.props.systemSettings.mctlVersionNumber,
        });
    };

    update = () => {
        this.setState({ validate: true });
        const { mclVersionNumber, mctlVersionNumber } = this.state;

        const params = {
            _id: this.props.systemSettings._id,
            mclVersionNumber: Number(mclVersionNumber),
            mctlVersionNumber: Number(mctlVersionNumber),
        };
        this.props.showLoader(true);
        updateSystemSettings(params)
            .then((data) => {
                this.props.showLoader(false);
                this.props.putSystemSettings(data.data);
                this.props.showMessage({
                    show: true,
                    message: {
                        type: 'success',
                        text: 'Setting has been updated',
                    },
                });
            })
            .catch((error) => {
                this.props.showLoader(false);
                this.props.handleHTTPError(error);
            });
    };

    render() {
        return (
            <PageContentLayout title="General Settings">
                <Row className="mb-4">
                    <TextBox
                        label="MCL Version Number"
                        tabIndex="0"
                        id="mclVersionNumber"
                        name="mclVersionNumber"
                        type="text"
                        className="col-md-3"
                        validate={this.state.validate}
                        value={this.state.mclVersionNumber}
                        placeholder="36"
                        onBlur={() => {}}
                        onChange={(mclVersionNumber, e) => {
                            this.setState({ mclVersionNumber });
                        }}
                        validationOption={{
                            type: 'number',
                            numberType: 'int',
                            check: true,
                            required: true,
                            showMsg: false,
                        }}
                    />
                    <TextBox
                        label="MCTL Version Number"
                        tabIndex="0"
                        id="mctlVersionNumber"
                        name="mctlVersionNumber"
                        type="text"
                        className="col-md-3"
                        validate={this.state.validate}
                        value={this.state.mctlVersionNumber}
                        placeholder="36"
                        onBlur={() => {}}
                        onChange={(mctlVersionNumber, e) => {
                            this.setState({ mctlVersionNumber });
                        }}
                        validationOption={{
                            type: 'number',
                            numberType: 'int',
                            check: true,
                            required: true,
                            showMsg: false,
                        }}
                    />
                    <Col md={3} className="d-flex align-items-end">
                        <Button color="secondary" block className="btn btn-lg mb-0" onClick={this.update}>
                            update
                        </Button>
                    </Col>
                </Row>
            </PageContentLayout>
        );
    }
}

const mapStateToProps = ({ user, ui }) => {
    const { isLoader } = ui;
    const { authUser, systemSettings } = user;
    return { authUser, isLoader, systemSettings };
};

export default withRouter(
    connect(mapStateToProps, {
        showLoader,
        showMessage,
        handleHTTPError,
        putSystemSettings,
    })(GeneralSetting),
);
